import { slugify } from "@/common/helpers/string";
import { removeTags } from "./remove-tags";

export { DelayedRender } from "./delayed-render";
export { removeTags } from "./remove-tags";
export { SafeHydrate } from "./safe-hydrate";
export { getIsMobile, useMobile } from "./use-mobile";

export const prepareAnchorId = (text: string) => slugify(removeTags(text));

export { compose } from "./compose";
export { isMedia } from "./is-media";
export { toBase64 } from "./to-base64";
export { truncateAtPeriod } from "./truncate-at-period";
